<template>
  <div class="footer">
    <span class="m-h-15">
      <span class="m-r-5">©{{ year }}</span>
      <span v-for="(copyright, index) in $copyrights" :key="`copyright-${index}`">
        <span v-if="index" class="sep">|</span>
        <a :href="copyright.link" target="_blank">{{ copyright.name }}</a>
      </span>
      <span><span v-if="$copyrights.length > 1">联合</span>出品</span>
    </span>
    <span class="m-h-15">
      <span v-for="(icp, index) in $icps" :key="`icp-${index}`">
        <span v-if="index" class="sep">|</span>
        <span>{{ icp }}</span>
      </span>
    </span>
  </div>
</template>
<script>
export default {
  data () {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../../styles/vars";

.footer {
  text-align: center;
  background-color: #333;
  height: $footer-height;
  padding: 22px 10px;
  font-size: 0.8rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  .sep {
    margin: 0 2px;
  }
  &, a {
    color: #808080;
  }
  a {
    text-decoration: none;
  }
}

@media screen and (max-width: 1000px) {
  .footer {
    flex-direction: column;
    > span {
      display: block;
      margin: 3px 0;
    }
  }
}
</style>
